import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';

function PieChart({ data, colors, options, chartTitle }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const pieOptions = {
      colors,
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: { enabled: false },
      showInLegend: false,
      ...options,
    };

    Highcharts.chart(containerRef?.current, {
      chart: {
        type: 'pie',
        backgroundColor: null,
        margin: 0,
        height: containerRef?.current?.offsetWidth,
      },
      title: {
        text: chartTitle,
        style: { display: 'none' },
      },
      tooltip: { pointFormat: '' },
      credits: { enabled: false },
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
          focusBorder: {
            enabled: true,
          },
        },
      },
      plotOptions: {
        pie: {
          ...pieOptions,
          borderWidth: '0.02rem',
          borderColor: '#2E2E2E',
          accessibility: {
            pointDescriptionFormatter(point) {
              if (point.name === 'No data') {
                return `No data available to display`;
              }
              return `${point.name}`;
            },
          },
        },
        series: {
          states: {
            hover: { enabled: true },
          },
        },
      },
      series: [
        {
          data,
          name: chartTitle,
        },
      ],
    });
  }, [data, colors, options, chartTitle]);

  return <div ref={containerRef} />;
}

PieChart.propTypes = {
  data: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  chartTitle: PropTypes.string.isRequired,
};

export default PieChart;
